import PropTypes from 'prop-types';
// @mui
import { Stack, Box, useTheme, Dialog } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { CSSObject } from '@mui/material/styles';

interface IProps {
	children?: PropTypes.ReactElementLike | PropTypes.ReactElementLike[] | React.ReactNode;
	styleObj?: any;
	handleClick?: any;
	style?: CSSObject;
	open?: boolean;
	handleClose?: any;
}

export const DialogCard = (props: IProps) => {
	const theme = useTheme();
	const dstyle = props.style || {};
	return (
		<Dialog
			open={props.open || false}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			sx={{ '& .MuiPaper-root': { margin: '16px', ...dstyle } }}
		>
			<Box sx={{ padding: '12px' }}>
				<Stack spacing={0} overflow={'hidden'}>
					<Box sx={{ height: '40px' }}>
						<Box
							sx={{
								background: theme.palette.root.darkGrayed_028,
								width: '40px',
								height: '40px',
								textAlign: 'center',
								float: 'right',
								borderRadius: '8px',
								cursor: 'pointer',
							}}
						>
							<CloseIcon
								onClick={props.handleClose}
								sx={{ width: '20px', height: '40px', margin: 'auto' }}
							/>
						</Box>
					</Box>
					{props.children}
				</Stack>
			</Box>
		</Dialog>
	);
};

export const PlanCard = (props: IProps) => {
	return (
		<Box
			onClick={props.handleClick}
			sx={{
				borderRadius: '8px',
				display: 'flex',
				...props.styleObj,
			}}
		>
			{props.children}
		</Box>
	);
};

export const SmallCard = (props: IProps) => {
	return (
		<Box
			sx={{
				minWidth: '225px',
				borderRadius: '8px',
				padding: '12px 15px 12px 15px',
				boxShadow: '0px 0px 1px rgba(0, 58, 53, 0.2), 4px 4px 8px rgba(0, 58, 53, 0.2)',
				//'&:hover': { display: 'none' },
				...props.styleObj,
				transition: '.3s ease',
				boxSizing: 'border-box',
				border: '1px solid #fff',
				'&:hover': { border: '1px solid #c7e5de' },
			}}
			onClick={() => props.handleClick && props.handleClick()}
		>
			{props.children}
		</Box>
	);
};
